import { render, staticRenderFns } from "./AssessmentCentre.vue?vue&type=template&id=59f5d552"
import script from "./AssessmentCentre.vue?vue&type=script&lang=js"
export * from "./AssessmentCentre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports